import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FormServiceFieldGeneralDataProcessingCountries } from "./dataProcessingInCountries.js";
import { FormServiceFieldGeneralDataProcessingCountriesSpecialTreatment } from "./dataProcessingInCountriesSpecialTreatment.js";
import { FormServiceFieldGeneralGroup } from "./group.js";
import { FormServiceFieldGeneralLegalBasis } from "./legalBasis.js";
import { FormServiceFieldGeneralName } from "./name.js";
import { FormServiceFieldGeneralProvider } from "./provider.js";
import { FormServiceFieldGeneralProviderContact } from "./providerContact.js";
import { FormServiceFieldGeneralProviderLegalNoticeUrl } from "./providerLegalNoticeUrl.js";
import { FormServiceFieldGeneralProviderPrivacyPolicyUrl } from "./providerPrivacyPolicyUrl.js";
import { FormServiceFieldGeneralPurpose } from "./purpose.js";
import { FormServiceFieldGeneralStatus } from "./status.js";
import { useI18n } from "../../../../../contexts/i18n.js";
import { LearnMoreTag } from "../../../../common/learnMoreTag.js";
import { FormHeadline } from "../../../headline.js";
import { FormServiceLayout } from "../../../layout.js";
const FormServiceFieldGeneralCompose = ()=>{
    const { __ } = useI18n();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(FormHeadline, {
                offset: FormServiceLayout.labelCol.span,
                children: [
                    __("General service configuration"),
                    " ",
                    /*#__PURE__*/ _jsx(LearnMoreTag, {
                        url: __("https://devowl.io/knowledge-base/real-cookie-banner-create-individual-cookie/")
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(FormServiceFieldGeneralName, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldGeneralStatus, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldGeneralGroup, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldGeneralProvider, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldGeneralProviderContact, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldGeneralPurpose, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldGeneralProviderPrivacyPolicyUrl, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldGeneralProviderLegalNoticeUrl, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldGeneralLegalBasis, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldGeneralDataProcessingCountries, {}),
            /*#__PURE__*/ _jsx(FormServiceFieldGeneralDataProcessingCountriesSpecialTreatment, {})
        ]
    });
};
export { FormServiceFieldGeneralCompose };
